import React from "react";

interface ProductEnergyRatingProps {
    energyRating: string;
    ukEnergyRatingRegUrl?: string;
    euEnergyRatingRegUrl?: string;
}

const ProductEnergyRating = (props:ProductEnergyRatingProps) => {
    const energyRatingImageUrl = (energyRating: string) => {
        return (
            `/assets/images/product/${energyRating.toUpperCase()}_Right.png`
        )
    }

    return (
        (
            props.energyRating != undefined && props.energyRating !== ""
                ? props.euEnergyRatingRegUrl != null && props.ukEnergyRatingRegUrl != null
                    ? <div className="energy-rating extra"><img src={energyRatingImageUrl(props.energyRating)} /> <div className="link-container"><a href={props.ukEnergyRatingRegUrl}>UK</a> <br/> <a href={props.ukEnergyRatingRegUrl}>EU</a></div></div>
                    : props.euEnergyRatingRegUrl != null
                        ? <div className="energy-rating"> <a href={props.euEnergyRatingRegUrl}><img src={energyRatingImageUrl(props.energyRating)} /></a> </div>
                        : <div className="energy-rating"> <a href={props.ukEnergyRatingRegUrl}><img src={energyRatingImageUrl(props.energyRating)} /></a> </div>
                : null
        )
    )
}

export default ProductEnergyRating